import setIdReduxAction from 'modules/redux/actions/set-id'
import { TRAINING_USERS_ACTION, TRAINING_USERS_PATH } from 'modules/training/modules/training-users/constants'

function setCurrentTrainingUserAction (instance) {
  return setIdReduxAction({
    type: instance ? TRAINING_USERS_ACTION.UPDATE_CURRENT : TRAINING_USERS_ACTION.DELETE_CURRENT,
    payload: {
      path: TRAINING_USERS_PATH.CURRENT,
      instance
    }
  })
}

export default setCurrentTrainingUserAction
